import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import "./theme.css";
import { ProUserPage } from "./pages/Pro/ProUserPage";
import { UserStorage } from "./context/UserContext";
import { Header } from "./components/layout/Header";
import { LeftMenu } from "./components/layout/LeftMenu";
import { Content } from "./components/layout/Content";
import { RequirePro } from "./utils/RequirePro";
import { Login } from "./pages/Login/Login";
import { Logout } from "./pages/Login/Logout";
import { RequireAdmin } from "./utils/RequireAdmin";
import { LoginCreate } from "./pages/Login/LoginCreate";
import { NewAct } from "./pages/Admin/NewAct";
import { DataStorage } from "./context/DataContext";
import { AdminPage } from "./pages/Admin/AdminPage";
import { AdminMind } from "./pages/Admin/AdminMind";
import { AdminMove } from "./pages/Admin/AdminMove";
import { AdminNutri } from "./pages/Admin/AdminNutri";
import { AdminValues } from "./pages/Admin/AdminValues";
import { EditAct } from "./pages/Admin/EditAct";
import { AdminUsers } from "./pages/Admin/AdminUsers";
import { MeetingNew } from "./pages/Admin/MeetingNew";
import { AdminMeetings } from "./pages/Admin/AdminMeetings";
import { MeetingDetails } from "./pages/Admin/MeetingDetails";
import { ProMeetingDetails } from "./pages/Pro/ProMeetingDetails";
import { MeetingEdit } from "./pages/Admin/MeetingEdit";
import { UserMeetingDetails } from "./pages/User/UserMeetingDetails";
import { RequireAuth } from "./utils/RequireAuth";
import Home from "./pages/Home/Home";
import ExploreSection from "./components/ExploreSection/ExploreSection";
import Privacy from "./pages/Privacy/Privacy";
import CookiesPage from "./pages/Cookies/Cookies";
import Terms from "./pages/Terms/Terms";
import UserDashboard from "./pages/UserDashboard/UserDashboard";
import { TopbarLayout } from "./components/layout/TopbarLayout";
import { AdminUserNew } from "./pages/Admin/AdminUserNew";
import { TherapyMeeting } from "./pages/TherapyMeeting/TherapyMeeting";
import PlannerPage from "./pages/Planner/Planner";
import LibraryPage from "./pages/Library/Library";
import PersonalityQuiz from "./pages/PersonalityQuiz/PersonalityQuiz";
import ProfilePage from "./pages/Profile/ProfilePage";
import { AccountPage } from "./pages/Account/AccountPage";
import ProfileInsights from "./pages/ProfileInsights/ProfileInsights";
import RegistrationPage from "./pages/RegistrationPage/RegistrationPage";
import AdminRegistrations from "./pages/Admin/AdminRegistrations";
import Pricing from "./pages/PremiumPurchase/Pricing";
import { NavbarLayout } from "./components/layout/NavbarLayout";
import Results from "./pages/PersonalityQuiz/Results";
import { NotFound } from "./pages/Home/NotFound";
import About from "./pages/About/About";
import PaymentSuccess from "./pages/PremiumPurchase/PaymentSuccess";

function App() {
  return (
    <UserStorage>
      <DataStorage>
        <Routes>
          <Route element={<NavbarLayout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/registration" element={<RegistrationPage />} />
            <Route path="/explore" element={<ExploreSection />} />
            <Route path="login/*" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/personality-quiz" element={<PersonalityQuiz />} />
            <Route path="/results" element={<Results />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route element={<TopbarLayout />}>
              <Route path="/" element={<UserDashboard />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/insights" element={<ProfileInsights />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/meeting/:id" element={<UserMeetingDetails />} />
              <Route path="/planner" element={<PlannerPage />} />
              <Route path="/library" element={<LibraryPage />} />
            </Route>
          </Route>
          <Route element={<RequirePro />}>
            <Route element={<TopbarLayout />}>
              <Route path="/prouser" element={<ProUserPage />} />
              <Route
                path="/prouser/meeting/:id"
                element={<ProMeetingDetails />}
              />
              <Route path="/therapy-meeting" element={<TherapyMeeting />} />
            </Route>
          </Route>
          <Route element={<RequireAdmin />}>
            <Route element={<TopbarLayout />}>
              <Route path="/admin/register" element={<AdminUserNew />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/meetings" element={<AdminMeetings />} />
              <Route path="/admin/newmeeting" element={<MeetingNew />} />
              <Route path="/admin/meeting/:id" element={<MeetingDetails />} />
              <Route path="/admin/meeting/edit/:id" element={<MeetingEdit />} />
              <Route path="/admin/newact" element={<NewAct />} />
              <Route path="/admin/editact" element={<EditAct />} />
              <Route path="/admin/mind" element={<AdminMind />} />
              <Route path="/admin/move" element={<AdminMove />} />
              <Route path="/admin/nutri" element={<AdminNutri />} />
              <Route path="/admin/values" element={<AdminValues />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route
                path="/admin/registrations"
                element={<AdminRegistrations />}
              />
            </Route>
          </Route>
        </Routes>
      </DataStorage>
    </UserStorage>
  );
}

export default App;
